// A variation's processing state (migration 102): a url means ready, even if processing_error
// is also set; no url means failed when processing_error is set, processing otherwise.
export function variationState({ url, processing_error: processingError }) {
  if (url) return "ready";
  return processingError ? "failed" : "processing";
}

// A variation claimed this long ago and still without a url is the sweeper's to time out;
// the screen stops treating it as in progress. Rows from before the pipeline (no
// processing_started_at) never count as in progress.
export const LIVE_PROCESSING_MS = 3 * 60 * 60 * 1000;

export function isLiveProcessing(variation, now = Date.now()) {
  return variationState(variation) === "processing" && !!variation.processing_started_at &&
    now - new Date(variation.processing_started_at).getTime() < LIVE_PROCESSING_MS;
}

// What a creative's card shows. creatives.status_id stays 3 (Inactive) until its first
// variation goes live, so the status alone cannot tell a new upload from one turned off:
//   - any ready audio: the creative's own status, "active" or "inactive";
//   - else audio claimed recently: "processing";
//   - else audio that failed: "failed";
//   - else (no audio, or old rows stuck without a claim): the creative's own status.
export function creativePhase({ status_id: statusId, audio_files: audioFiles = [] }, now = Date.now()) {
  const own = statusId === 1 ? "active" : "inactive";
  if (audioFiles.some((v) => variationState(v) === "ready")) return own;
  if (audioFiles.some((v) => isLiveProcessing(v, now))) return "processing";
  if (audioFiles.some((v) => variationState(v) === "failed")) return "failed";
  return own;
}
